(function ($) {
    $(document).ready(function () {
        setTimeout(() => {
            jQuery('ul.regions-list a').hover(
                function () {
                    jQuery('.map .' + jQuery(this).attr('data-region')).addClass('active');
                },
                function () {
                    jQuery('.map .' + jQuery(this).attr('data-region')).removeClass('active');
                }
            );
    
            jQuery('.map a').hover(
                function () {
                    jQuery(this).addClass('active');
                },
                function () {
                    jQuery(this).removeClass('active');
                }
            );
           
            $(".region-map .regions-list .region h6").on('click', function () {
                $(this).parent().toggleClass('active');
                $(this).parent().siblings('').removeClass('active'); 
            });
        },1500)
    });

   

})(jQuery);